import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();

function Inventory(params: any): any {
    const { search,limit ,pages} = params.data;
    return api.get(`${URL.GET_INVENTORY}search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
    // search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}
}

function updateInventory(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_INVENTORY, data);
}

function ProfitLoss(params: any): any {
    const { search } = params.data;
    return api.get(`${URL.PROFIT_LOSS_GET}search=${encodeURIComponent(search)}`);
    // search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}
}

export {Inventory,updateInventory, ProfitLoss };
